import React from "react";
import {
  CardContainer,
  CardIcon,
  CardItems,
  CardLabel,
  CardLink,
} from "./ContactCardElements";

const ContactCard = ({ icon: Icon, label, items }) => {
  return (
    <CardContainer>
      <CardIcon>
        <Icon />
      </CardIcon>
      <CardLabel>{label}</CardLabel>
      <CardItems>
        {items.map((item) => (
          <CardLink
            key={item.href}
            href={item.href}
            {...(item.external && {
              target: "_blank",
              rel: "noopener noreferrer",
            })}
          >
            {item.text}
          </CardLink>
        ))}
      </CardItems>
    </CardContainer>
  );
};

export default ContactCard;
